export const DistrictListSkeleton = () => {
	return (
		<div className="mx-4 flex w-full animate-pulse flex-col gap-8 pt-6 sm:mx-8 xl:mx-0">
			<div className="h-12 w-40 rounded bg-gray-200"></div>
			<div className="h-12 w-full rounded bg-gray-200"></div>
			<div className="h-12 w-full rounded bg-gray-200"></div>
			<div className="h-12 w-full rounded bg-gray-200"></div>
			<div className="h-12 w-full rounded bg-gray-200"></div>
			<div className="h-12 w-full rounded bg-gray-200"></div>
		</div>
	);
};
